export async function delay(ms: number){
    return new Promise((resolve, reject) =>setTimeout(resolve, ms))
}
